import { useEffect, useCallback } from "react";
import { useDispatch, useStoreState } from "../store/useStore";

const useResponsiveHandlers = (position: string) => {
  const { dispatch } = useDispatch();

  const { defaultTheme, themeLock } = useStoreState();

  const handleResize = useCallback(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1000) {
      dispatch({ type: "SET_DRAWEROPEN", payload: false });
    }
  }, [dispatch]);

  const handleScroll = useCallback(() => {
    const isSticky = window.scrollY > 0;

    dispatch({ type: "SET_ISSTICKY", payload: isSticky });

    if (!themeLock) {
      dispatch({
        type: "SET_THEME",
        payload: { theme: isSticky ? "light" : defaultTheme ? defaultTheme : "dark" }
      });
    }
  }, [dispatch, defaultTheme, themeLock]);

  useEffect(() => {
    requestAnimationFrame(handleScroll);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    if (position === "sticky") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      if (position === "sticky") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleResize, handleScroll, position]);
};

export default useResponsiveHandlers;
